import * as React from 'react';
import TextCompareComponent from './TextCompareComponent';
import TwoLanguageInput from './TwoLanguageInput';
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import ShortTextCompareComponent from './ShortTextCompareComponent';
import HATEOASClient from 'src/services/HATEOASClient';
import {ResourceListOfOptionDto} from 'src/services/Client';

interface TwoLanguageCompareInputProps extends IVirtualizedTableCellComponentProps {
    isEditor:boolean;
    globalSearch?: string;
    isNewGrid: boolean;
    client?: HATEOASClient;
    postOptions?: ResourceListOfOptionDto;
    pslAiGeneratedLongtext?: boolean;
    pslAiGeneratedShorttext?:boolean;
    aiGeneratedUsp?:boolean;
    aiGeneratedFooter?:boolean;
    apiMethod?: (client: HATEOASClient, postOptions: ResourceListOfOptionDto) => {execute: (payload: any) => Promise<any>};
    grammarApiMethod?: (client: HATEOASClient, postOptions: ResourceListOfOptionDto) => {execute: (payload: any) => Promise<any>};
}

export const TwoLanguageCompareInput: React.StatelessComponent<TwoLanguageCompareInputProps> = (props: TwoLanguageCompareInputProps) => {

    return (
        <div className="display--flex">
            {!props.uglyMode &&
                <div className="textCompare">
                    <ShortTextCompareComponent
                        value={props.value}
                        onChange={props.onChange}
                        isSpecificPSL={props.isSpecificPSL}
                        maintainedTextsIconColor={props.maintainedTextsIconColor}
                        inEditMode={props.inEditMode ? props.inEditMode : false}
                        readOnly={props.readOnly}
                        t={props.t}
                    />
                </div>
            }
            <div style={{ width: '100%', maxWidth: 'fill-available'}}>
                <TwoLanguageInput
                    {...props}
                />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/TwoLanguageCompareInput.tsx